import styled from "styled-components";

export const NoticeIframe = styled.iframe`
  width: 100%;
  height: 00px;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const NoticeEditorWrapper = styled.div`
  width: 100%;
  min-height: 600px;

  .quill {
    height: 100%;
  }

  .ql-container {
    min-height: 500px;
    font-family: Pretendard, sans-serif;
    font-size: 14px;
  }

  .ql-editor {
    min-height: 500px;
  }

  .ql-toolbar {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px solid #d9d9d9;
    border-bottom: none;
  }

  .ql-container {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #d9d9d9;
    border-top: none;
  }

  .ql-editor.ql-blank::before {
    font-style: normal;
    color: #999;
  }

  /* size picker에서 NORMAL 텍스트 숨기고 data-value만 표시 */
  .ql-toolbar .ql-size .ql-picker-label,
  .ql-toolbar .ql-size .ql-picker-item {
    font-size: 0;
    line-height: 0;

    &::before {
      content: attr(data-value);
      font-size: 13px;
      line-height: normal;
    }
  }
`;
